import { put, takeEvery } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { lookupActionCreators } from '..';
import { IState } from '../..';
import * as api from '../lookupsApi';

function* fetchCountiesSaga(action: ReturnType<typeof lookupActionCreators.fetchCounties>) {
  const loaded = yield* select((state: IState) => state.lookups.counties[action.payload.stateFipsId]);

  if (!Boolean(loaded)) {
    const counties = yield* call(api.FetchCounties, action.payload.stateFipsId);

    yield put(lookupActionCreators.setCounties(action.payload.stateFipsId, counties));
  }
}

export function* watchFetchCounties() {
  yield takeEvery(lookupActionCreators.fetchCounties.match, fetchCountiesSaga);
}
